// SPDX-License-Identifier: AGPL-3.0-or-later

// Discord numbers. Text input and label appear only in modals; 9-14 and 17 only in Components v2 messages.
export const MessageComponentTypes = {
	ACTION_ROW: 1,
	BUTTON: 2,
	STRING_SELECT: 3,
	TEXT_INPUT: 4,
	USER_SELECT: 5,
	ROLE_SELECT: 6,
	MENTIONABLE_SELECT: 7,
	CHANNEL_SELECT: 8,
	SECTION: 9,
	TEXT_DISPLAY: 10,
	THUMBNAIL: 11,
	MEDIA_GALLERY: 12,
	FILE: 13,
	SEPARATOR: 14,
	CONTAINER: 17,
	LABEL: 18,
} as const;
export const ButtonStyles = {PRIMARY: 1, SECONDARY: 2, SUCCESS: 3, DANGER: 4, LINK: 5} as const;
export const TextInputStyles = {SHORT: 1, PARAGRAPH: 2} as const;
export const SeparatorSpacing = {SMALL: 1, LARGE: 2} as const;
export const SelectDefaultValueTypes = {USER: 'user', ROLE: 'role', CHANNEL: 'channel'} as const;
export const MESSAGE_COMPONENT_LIMITS = {
	rows: 5,
	buttonsPerRow: 5,
	labelMax: 80,
	customIdMax: 100,
	linkUrlMax: 512,
	selectOptionsMax: 25,
	selectOptionTextMax: 100,
	placeholderMax: 150,
	selectValuesMax: 25,
	v2ComponentsMax: 40,
	v2TextMax: 4000,
	v2DepthMax: 3,
	v2JsonBytesMax: 32_768,
	sectionTextsMax: 3,
	mediaGalleryItemsMax: 10,
	mediaDescriptionMax: 1024,
	modalTitleMax: 45,
	modalComponentsMax: 5,
	textInputLabelMax: 45,
	labelDescriptionMax: 100,
	textInputPlaceholderMax: 100,
	textInputValueMax: 4000,
} as const;

// A closed set: the server never sends free text in a click reply, the client shows a translated message for each code.
export const MESSAGE_COMPONENT_REPLY_CODES = [
	'component_unavailable',
	'roster_joined',
	'roster_already_joined',
	'roster_left',
	'roster_not_joined',
	'roster_full',
	'roster_closed',
	'roster_busy',
] as const;
export type MessageComponentReplyCode = (typeof MESSAGE_COMPONENT_REPLY_CODES)[number];
